import "@/styles/portfolio.css";
import { ArrowUpRight } from "lucide-react";
import { useT } from "@/i18n/LangProvider";

/**
 * Portfolio project data is language-agnostic (brand names, URLs, city).
 * Category and description come from translations, keyed per project.
 */
const projects = [
  {
    key: "kosmedico",
    catKey: "aesthetic-medicine",
    location: "Zürich",
    name: "Kosmedico",
    url: "kosmedico.zuerich",
    href: "https://kosmedico.zuerich/",
    image: "/portfolio/kosmedico.jpg?v=5",
  },
  {
    key: "gelbepfoten",
    catKey: "pet-care",
    location: "Schweiz",
    name: "Gelbe Pfoten",
    url: "gelbepfoten.ch",
    href: "https://gelbepfoten.ch/",
    image: "/portfolio/gelbepfoten.jpg?v=2",
  },
  {
    key: "carol",
    catKey: "pet-sitting",
    location: "Schweiz",
    name: "Carol Tierbetreuung",
    url: "carol-tierbetreuung.ch",
    href: "https://carol-tierbetreuung.ch/",
    image: "/portfolio/carol.jpg?v=2",
  },
  {
    key: "balbino",
    catKey: "accounting",
    location: "Schweiz",
    name: "Balbino",
    url: "balbino.ch",
    href: "https://balbino-preview.preview.emergentagent.com/",
    image: "/portfolio/balbino.jpg?v=3",
  },
  {
    key: "amanlux",
    catKey: "animals",
    location: "",
    name: "Amanlux",
    url: "amanlux.com",
    href: "https://darkcyan-squid-833886.hostingersite.com/",
    image: "/portfolio/amanlux.jpg?v=3",
  },
  {
    key: "portugal",
    catKey: "news",
    location: "Portugal",
    name: "Portugal à Vista",
    url: "portugalavista.pt",
    href: "https://portuga-backoffice.preview.emergentagent.com/",
    image: "/portfolio/portugal.jpg?v=1",
  },
];

export default function Portfolio() {
  const { t } = useT();

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="section"
      style={{ background: "var(--navy-light)" }}
    >
      <div className="section-inner">
        <p className="eyebrow fade-up">{t("portfolio.eyebrow")}</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-16 fade-up">
          {t("portfolio.title1")}{" "}
          <em className="text-[color:var(--gold-light)]">
            {t("portfolio.title_em")}
          </em>{" "}
          {t("portfolio.title2")}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {projects.map((p, i) => {
            const cat = t(`portfolio.cats.${p.catKey}`);
            const desc = t(`portfolio.descriptions.${p.key}`);
            return (
              <a
                key={p.name}
                href={p.href}
                target="_blank"
                rel="noopener noreferrer"
                className="pf-card fade-up no-underline"
                data-testid={`portfolio-card-${i}`}
              >
                <div className="pf-frame">
                  <div className="pf-browser-bar">
                    <i /><i /><i />
                    <span className="pf-url">{p.url}</span>
                  </div>
                  <div className="pf-scroll">
                    <img
                      src={p.image}
                      alt={`${p.name} — website`}
                      className="pf-shot"
                      loading="eager"
                      fetchPriority="high"
                      decoding="async"
                      draggable="false"
                    />
                  </div>
                </div>

                <div className="pf-meta">
                  <span className="pf-cat">
                    {cat}
                    {p.location ? ` · ${p.location}` : ""}
                  </span>
                  <h3 className="pf-name">{p.name}</h3>
                  <p className="pf-desc">{desc}</p>
                  <span className="pf-visit">
                    {t("portfolio.visit")}
                    <ArrowUpRight className="w-3 h-3" strokeWidth={2} />
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
